import { get } from '../../helpers/api_helper';

export const getCategorySalesComparison = ({
  comparisonEnd,
  comparisonStart,
  currentEnd,
  currentStart,
  site,
  timezone,
}) => {
  const params = new URLSearchParams({
    comparisonEnd,
    comparisonStart,
    currentEnd,
    currentStart,
    timezone,
  });

  if (site) {
    params.set('site', site);
  }

  return get(`/api/sales/reports/categories/sales-comparison?${params.toString()}`);
};

export default getCategorySalesComparison;
